export default [
  {
    stylers: [
      { saturation: -75 },
      { lightness: 10 },
      { hue: '#CAD8EA' },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      { visibility: 'off' },
    ],
  },
];
